export const convertCamelToSpace = (inputString: string): string => {
  return inputString.replaceAll(/([A-Z])/g, ' $1').toLowerCase();
};
